const axios = require("axios")

export const contactFormApi = axios.create({
  baseURL: `${process.env.GATSBY_WORDPRESS_URL}/wp-json/contact-form-7/v1/contact-forms`,
})
export const mediaApi = axios.create({
  baseURL: `${process.env.GATSBY_WORDPRESS_URL}/wp-json`,
})
